import React from 'react';
import { FaFileAlt, FaPoll, FaImages, FaStream, FaTimes, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const typeIcons = {
  post: FaFileAlt,
  poll: FaPoll,
  carousel: FaImages,
  thread: FaStream,
};

const typeLabels = { post: 'Point', poll: 'Poll', carousel: 'Carousel', thread: 'Talk' };

const formatTimeAgo = (dateStr) => {
  const diff = Date.now() - new Date(dateStr).getTime();
  if (diff < 60000) return 'just now';
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ago`;
  return `${Math.floor(diff / 86400000)}d ago`;
};

const getDraftPreview = (draft) => {
  if (draft.post_type === 'poll') return draft.poll_question || 'Untitled poll';
  if (draft.post_type === 'thread' && draft.thread_posts?.length > 0) return draft.thread_posts[0]?.content || 'Untitled talk';
  return draft.content || 'Untitled draft';
};

const DraftsDropdown = ({ drafts, expanded, setExpanded, onLoad, onDelete }) => {
  if (drafts.length === 0) return null;

  return (
    <div className="mb-4" data-testid="drafts-section">
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-700 hover:bg-amber-100 transition-colors"
        data-testid="drafts-toggle-btn"
      >
        <span className="font-medium">Drafts ({drafts.length})</span>
        {expanded ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
      </button>

      {expanded && (
        <div className="mt-2 border border-gray-200 rounded-lg overflow-hidden max-h-48 overflow-y-auto" data-testid="drafts-list">
          {drafts.map((draft) => {
            const Icon = typeIcons[draft.post_type] || FaFileAlt;
            return (
              <div
                key={draft.id}
                className="flex items-center p-2.5 hover:bg-gray-50 border-b border-gray-100 last:border-b-0 group cursor-pointer"
                onClick={() => onLoad(draft)}
                data-testid={`draft-item-${draft.id}`}
              >
                <div className="w-7 h-7 rounded-md bg-[#4A90E2]/10 flex items-center justify-center mr-2.5 flex-shrink-0">
                  <Icon className="text-[#4A90E2]" size={12} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-gray-800 truncate">{getDraftPreview(draft)}</p>
                  <p className="text-xs text-gray-400"><span className={typeLabels[draft.post_type] === 'Point' ? 'font-arthaus' : ''}>{typeLabels[draft.post_type]}</span> · {formatTimeAgo(draft.updated_at)}</p>
                </div>
                <button
                  type="button"
                  onClick={(e) => { e.stopPropagation(); onDelete(draft.id); }}
                  className="p-1.5 text-gray-300 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
                  data-testid={`draft-delete-${draft.id}`}
                >
                  <FaTimes size={11} />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DraftsDropdown;
